import { render, staticRenderFns } from "./checkCampaign.vue?vue&type=template&id=397e82d0&scoped=true"
import script from "./checkCampaign.vue?vue&type=script&lang=js"
export * from "./checkCampaign.vue?vue&type=script&lang=js"
import style0 from "./checkCampaign.vue?vue&type=style&index=0&id=397e82d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e82d0",
  null
  
)

export default component.exports